import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { client } from '../amplify-client';
import { GuennieRating } from '../components/GuennieRating';
import { SpaghettiDivider } from '../components/SpaghettiDivider';

type Kartenpunkt = {
  id: string;
  name: string;
  ort: string;
  anzahlTests: number;
  avgGesamtGuennies?: number | null;
};

type Sortierung = 'guennies' | 'name' | 'anzahl';

export function Eisdielen() {
  const [liste, setListe] = useState<Kartenpunkt[]>([]);
  const [laedt, setLaedt] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);
  const [sortierung, setSortierung] = useState<Sortierung>('guennies');

  useEffect(() => {
    client.queries
      .karteEisdielen()
      .then(({ data }) => setListe((data ?? []).filter(Boolean) as Kartenpunkt[]))
      .catch((e) => setFehler(String(e?.message ?? e)))
      .finally(() => setLaedt(false));
  }, []);

  const sortiert = useMemo(() => {
    const kopie = [...liste];
    if (sortierung === 'name') return kopie.sort((a, b) => a.name.localeCompare(b.name, 'de'));
    if (sortierung === 'anzahl') return kopie.sort((a, b) => b.anzahlTests - a.anzahlTests);
    return kopie.sort((a, b) => (b.avgGesamtGuennies ?? 0) - (a.avgGesamtGuennies ?? 0));
  }, [liste, sortierung]);

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap' }}>
        <div>
          <p className="label">Der Führer</p>
          <h1>Eisdielen</h1>
        </div>
        <div>
          <label htmlFor="sort">Sortieren nach</label>
          <select id="sort" value={sortierung} onChange={(e) => setSortierung(e.target.value as Sortierung)}>
            <option value="guennies">meiste Günnies</option>
            <option value="anzahl">meiste Verkostungen</option>
            <option value="name">Name</option>
          </select>
        </div>
      </div>
      <SpaghettiDivider />

      {laedt ? <p className="label">Lädt …</p> : null}
      {fehler ? <p className="hinweis">Konnte die Liste nicht laden: {fehler}</p> : null}
      {!laedt && sortiert.length === 0 ? (
        <p style={{ color: 'var(--espresso-70)' }}>Noch keine getestete Eisdiele mit veröffentlichter Verkostung.</p>
      ) : null}

      <div
        style={{
          display: 'grid',
          gap: '1rem',
          gridTemplateColumns: 'repeat(auto-fill, minmax(15rem, 1fr))',
        }}
      >
        {sortiert.map((e) => (
          <Link key={e.id} to={`/app/eisdielen/${e.id}`} className="karte" style={{ textDecoration: 'none' }}>
            <strong style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem' }}>{e.name}</strong>
            <div style={{ color: 'var(--espresso-70)', fontSize: '0.9rem' }}>{e.ort}</div>
            <div style={{ marginTop: '0.5rem' }}>
              <GuennieRating wert={e.avgGesamtGuennies ?? null} groesse="sm" />
            </div>
            <div className="label" style={{ marginTop: '0.35rem' }}>
              {e.anzahlTests} Verkostung{e.anzahlTests === 1 ? '' : 'en'}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
